<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/invoice_top.jpg" />
      </div>
    </div>
  </section>

  <section class="msc_seminar mt-5">
    <p>本ページでは、2023年10月施行の適格請求書等保存形式（インボイス制度）への、マナビス化粧品の取り組みについての様々な情報をお伝えいたします。</p>
    <p class="mt-3">各詳細の内容をご確認いただき、適切にご対応いただきますよう、法令遵守へのご協力をよろしくお願いいたします。</p>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">■弊社の取組みのご案内</h3>
    <p>弊社の取り組みにつきましては、2023年7月までに、各地域において、Vランクの方々への説明会を実施いたしました。説明会にて社長の兼子が使用いたしました資料を公開いたしますので、以下のリンク先からPDFファイルを開いて、内容をご覧いただきますようお願い致します。</p>
    <p class="my-5 text-center">
      <a href="/web/assets/pdf/invoice_Rev03.pdf">インボイス制度説明会説明資料</a>
    </p>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">■メンバーズクラブ会員マニュアル改定</h3>
    <p>インボイス制度実施に伴いまして、2023年10月より、メンバーズクラブ会員マニュアルの一部が改定されます。具体的な改定内容につきましては、当該ページ部分を抜粋したものを用意いたしました。以下のリンク先からＰＤＦファイルを開いて、こちらの内容につきましてもご確認いただきますようお願いいたします。</p>
    <p class="my-5 text-center">
      <a href="/web/assets/pdf/invoice_manual.pdf">インボイス制度に伴う会員マニュアル改定詳細</a>
    </p>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">■登録番号（インボイス番号）報告方法のご案内</h3>
    <p>管轄税務署（国税庁）での適格事業者登録が完了されましたら、以下の専用登録フォームから必要情報をお知らせくださいますようお願いいたします。</p>
    <p class="mt-5 ml-5">★登録フォームへの入力に際してご用意いただくものは以下の通りです。ご準備をお願いいたします。<br>
      <span class="ml-3">・会員番号</span><br>
      <span class="ml-3">・登録番号（インボイス番号）</span><br>
      <span class="ml-3">・登録通知書（可能な限り）</span>
    </p>
    <div class="step_button">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSevg-fgbbeQK-RNDwQwrbgfdERNKBY6aDrBw-PR2FN26R4HSw/viewform?usp=sf_link" class="btn d-inline-block" target="_blank" >【ステップ1】<br>会員番号・インボイス番号登録フォームへ<br><span>タップ・クリックで専用のフォームが開きます</span></a>
    </div>
    <p class="mt-5 ml-5">★登録フォームへの登録が完了しましたら、以下のSTEP2ボタンをタップ・クリックしてください。</p>
    <p class="ml-5">★メールソフトが自動的に開きますので、本文に会員番号と氏名を入力し、登録通知書のファイルを添付して、そのまま[送信]ボタンを押してメールでお送りください。</p>
    <div class="step_button">
      <a href="mailto:mc-somu@manavis-cosme.co.jp?subject=%E3%82%A4%E3%83%B3%E3%83%9C%E3%82%A4%E3%82%B9%E7%95%AA%E5%8F%B7%E7%A2%BA%E8%AA%8D%E6%9B%B8%E9%A1%9E%E9%80%81%E4%BB%98&amp;body=%E6%9C%AC%E6%96%87%E3%81%AB%E4%BC%9A%E5%93%A1%E7%95%AA%E5%8F%B7%E3%81%A8%E6%B0%8F%E5%90%8D%E3%82%92%E5%85%A5%E5%8A%9B%E3%81%97%E3%80%81%E7%99%BB%E9%8C%B2%E9%80%9A%E7%9F%A5%E6%9B%B8%E3%81%AE%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E3%82%92%E6%B7%BB%E4%BB%98%E3%81%97%E3%81%A6%E3%80%81%E3%81%9D%E3%81%AE%E3%81%BE%E3%81%BE%5B%E9%80%81%E4%BF%A1%5D%E3%83%9C%E3%82%BF%E3%83%B3%E3%82%92%E6%8A%BC%E3%81%97%E3%81%A6%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%92%E3%81%8A%E9%80%81%E3%82%8A%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84%E3%80%82%0D%0A%E4%BC%9A%E5%93%A1%E7%95%AA%E5%8F%B7%EF%BC%9A%0D%0A%E6%B0%8F%E5%90%8D%EF%BC%9A%20" class="btn d-inline-block" target="_blank" >【ステップ2】<br>登録通知書の送信（メールでファイルを添付して送信）<br><span class="font-small">タップ・クリックでメールソフトが開きます</span></a>
    </div>
    <div class="step_button">
      <p>メールで送れない場合は、FAXをご利用ください。<br>
      FAX送信先：0120-269-510（24時間年中無休）<br>
      <span style="font-weight: bold;">登録通知書をFAXするとき、会員番号と氏名も一緒にお知らせください。</span></p>
    </div>
    <p class="mt-5 ml-5">★注意事項<br>
      <span class="ml-3">・適格請求書（インボイス）発行事業者の有無の判定は、月末日時点での登録状況にて判定いたします。</span><br>
      <span class="ml-3">・弊社へ登録番号を通知した月からの対応となります。</span><br>
      <span class="ml-3">・過去への遡及適用はいたしませんので、ご了承ください。</span>
    </p>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<!-- 化粧品公式サイトのスタイルを反映 -->
<style src="../../assets/css/custom.css" scoped>
</style>
<style src="../../assets/css/module.css" scoped>
</style>
<style src="../../assets/css/module_sp.css" scoped>
</style>
<style src="../../assets/css/top.css" scoped>
</style>

<style scoped>
.box-top-slide {
  height: initial;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}
.step_button {
  display: flex;
  justify-content: center;
  margin: 3rem 0 5rem 0;
}
.step_button a {
  padding: 3rem;
  text-align: center;
  width: 450px !important;
}
.step_button p {
  padding: 1rem;
  text-align: center;
  width: 512px !important;
  border: 1px solid #000;
}
.step_button a .font-small {
  font-size: 12pt;
}

@media screen and (min-width: 1px) and (max-width: 699px) {
  .msc_seminar .d-flex {
    flex-direction: column;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>